import React from 'react';
import { observer, inject } from 'mobx-react';
import style from './style.module.css';
import Modal from 'react-modal';
import welcome from 'assets/welcome_bg_top.png';
import { withTranslation } from 'react-i18next';

@inject(store => {
    const { myShopApiStore, ifaceMngr } = store;
    return { myShopApiStore, ifaceMngr };
})
@observer
class WelcomeModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalStyle = {
            content : {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '20px',
                margin: 0,
                padding: 0,
                background: `url(${welcome}) no-repeat`,
                backgroundSize: '100%',
                backgroundPosition: 'top',
                backgroundColor: 'var(--mainColor)',
                maxHeight: '100%',
                width: '450px',
                height: '243px',
                overflow: 'hidden',
                
            },
            overlay: {
                backgroundColor: "rgb(0, 0, 0, 0.65)",
                zIndex: 10
            }
        }
    }

    goMenu = () => {
        const { setActiveTopMenu } = this.props.ifaceMngr;
        const { closeModal } = this.props;
        
        setActiveTopMenu("ShopMenu");
        closeModal();
    }
    render() {
        const { modalIsOpen } = this.props;
        const { shop } = this.props.myShopApiStore;
        const { i18nextLng } = this.props.ifaceMngr;
        const { t } = this.props;
        return (
            <Modal style={ this.modalStyle } isOpen={ modalIsOpen } onRequestClose={ this.goMenu } ariaHideApp={false}>
                <div className={style.ModalContainer}>
                    <h3>
                        {!i18nextLng || !shop || t('WelcomeTo', {shop})}
                    </h3>
                    <button type="button" onClick={ this.goMenu}>
                        {(process?.env.REACT_APP_DONATION ?? 'false') === 'true' ? t('continue') : t('GoToMenu')}
                    </button>
                </div>
            </Modal>
        )
    }
}
export default withTranslation()(WelcomeModal);